<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area">
            <div class="page-header">
                <div class="page-details">
                    <h2>Settings</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/employees'" class="current">Settings</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section d-flex justify-content-center">
                <div class="organisation__detail">
                    <img class="organisation__logo" :src="organizationDetails.full_image_path" />
                    <h4>{{ organizationDetails.name }}</h4>
                    <p>Started Since : {{ transactionDetails.subscripted_at }}</p>
                </div>
            </div>
            <div class="section">
                <div class="feature-bar">
                    <div class="feature">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M16.25 1.79073V31.1241M22.9167 7.12407H12.9167C11.679 7.12407 10.492 7.61573 9.61684 8.4909C8.74167 9.36607 8.25 10.5531 8.25 11.7907C8.25 13.0284 8.74167 14.2154 9.61684 15.0906C10.492 15.9657 11.679 16.4574 12.9167 16.4574H19.5833C20.821 16.4574 22.008 16.9491 22.8832 17.8242C23.7583 18.6994 24.25 19.8864 24.25 21.1241C24.25 22.3617 23.7583 23.5487 22.8832 24.4239C22.008 25.2991 20.821 25.7907 19.5833 25.7907H8.25" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="32" height="32" fill="white" transform="translate(0.25 0.457397)"></rect>
                                </clipPath>
                            </defs>
                        </svg>
                        <h5>{{ subscriptionDetails.name }}</h5>
                        <h6>Package</h6>
                    </div>
                    <div class="feature" v-bind:class="{'feature--alert': !isPaymentCleared}">
                        <svg v-if="isPaymentCleared" width="33" height="33" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
                            <path d="M 500 0C 224 0 0 224 0 500C 0 776 224 1000 500 1000C 776 1000 1000 776 1000 500C 1000 224 776 0 500 0C 500 0 500 0 500 0M 500 75C 735 75 925 265 925 500C 925 735 735 925 500 925C 265 925 75 735 75 500C 75 265 265 75 500 75C 500 75 500 75 500 75 M 250 475C 279 504 359 586 390 615C 400 625 410 615 410 615C 410 615 625 400 750 275C 765 260 785 260 800 275C 816 292 837 313 850 325C 865 340 865 360 850 375C 700 525 583 642 425 800C 410 815 390 815 375 800C 292 717 150 575 150 575C 135 560 135 540 150 525C 150 525 200 475 200 475C 215 461 235 460 250 475C 250 475 250 475 250 475" /></svg>
                        <svg v-if="!isPaymentCleared" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.2501 10.9711V16.3044M16.2501 21.6377H16.2634M29.5834 16.3044C29.5834 23.6682 23.6139 29.6377 16.2501 29.6377C8.88628 29.6377 2.91675 23.6682 2.91675 16.3044C2.91675 8.94061 8.88628 2.97107 16.2501 2.97107C23.6139 2.97107 29.5834 8.94061 29.5834 16.3044Z" stroke="url(#paint0_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <defs>
                                <linearGradient id="paint0_linear" x1="8.47258" y1="33.2333" x2="26.2856" y2="2.97195" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#EE0979" />
                                    <stop offset="1" stop-color="#FF6A00" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <h5 v-if="transactionDetails.payment_details">{{ transactionDetails.payment_details.payment_field_value }}</h5>
                        <h6 v-if="transactionDetails.payment_details">{{ transactionDetails.payment_details.payment_field_label }}</h6>
                    </div>
                    <div class="feature">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M23.4166 28.3044V25.6377C23.4166 24.2233 22.8547 22.8667 21.8545 21.8665C20.8543 20.8663 19.4977 20.3044 18.0833 20.3044H7.41658C6.0021 20.3044 4.64554 20.8663 3.64535 21.8665C2.64516 22.8667 2.08325 24.2233 2.08325 25.6377V28.3044M31.4166 28.3044V25.6377C31.4157 24.456 31.0224 23.3081 30.2984 22.3742C29.5744 21.4402 28.5608 20.7732 27.4166 20.4777M22.0833 4.47774C23.2305 4.77147 24.2473 5.43867 24.9734 6.37415C25.6996 7.30963 26.0937 8.46018 26.0937 9.64441C26.0937 10.8286 25.6996 11.9792 24.9734 12.9147C24.2473 13.8501 23.2305 14.5173 22.0833 14.8111M18.0833 9.63774C18.0833 12.5833 15.6954 14.9711 12.7499 14.9711C9.8044 14.9711 7.41658 12.5833 7.41658 9.63774C7.41658 6.69222 9.8044 4.30441 12.7499 4.30441C15.6954 4.30441 18.0833 6.69222 18.0833 9.63774Z" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="32" height="32" fill="white" transform="translate(0.75 0.457397)"></rect>
                                </clipPath>
                            </defs>
                        </svg>
                        <h5>{{ organizationDetails.employees_count }}/{{ subscriptionDetails.employees_count }}</h5>
                        <h6>
                            Employees
                            <a href="javascript:;" v-if="organizationDetails.employees_count == subscriptionDetails.employees_count" @click.prevent="upgradePlan">Upgrade</a>
                        </h6>
                    </div>
                    <div class="feature">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M23.4166 28.3044V25.6377C23.4166 24.2233 22.8547 22.8667 21.8545 21.8665C20.8543 20.8663 19.4977 20.3044 18.0833 20.3044H7.41658C6.0021 20.3044 4.64554 20.8663 3.64535 21.8665C2.64516 22.8667 2.08325 24.2233 2.08325 25.6377V28.3044M31.4166 28.3044V25.6377C31.4157 24.456 31.0224 23.3081 30.2984 22.3742C29.5744 21.4402 28.5608 20.7732 27.4166 20.4777M22.0833 4.47774C23.2305 4.77147 24.2473 5.43867 24.9734 6.37415C25.6996 7.30963 26.0937 8.46018 26.0937 9.64441C26.0937 10.8286 25.6996 11.9792 24.9734 12.9147C24.2473 13.8501 23.2305 14.5173 22.0833 14.8111M18.0833 9.63774C18.0833 12.5833 15.6954 14.9711 12.7499 14.9711C9.8044 14.9711 7.41658 12.5833 7.41658 9.63774C7.41658 6.69222 9.8044 4.30441 12.7499 4.30441C15.6954 4.30441 18.0833 6.69222 18.0833 9.63774Z" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="32" height="32" fill="white" transform="translate(0.75 0.457397)"></rect>
                                </clipPath>
                            </defs>
                        </svg>
                        <h5>{{ organizationDetails.admins_count }}/{{ subscriptionDetails.admins_count }}</h5>
                        <h6>
                            Admins
                            <a href="javascript:;" v-if="organizationDetails.admins_count == subscriptionDetails.admins_count" @click.prevent="upgradePlan">Upgrade</a>
                        </h6>
                    </div>
                    <div class="feature" v-bind:class="{'feature--inactive': subscriptionDetails.inactive_static_qr_label}">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.93604 3.64336V11.1181H11.4108V3.64336H3.93604ZM9.27532 8.98265H6.07181V5.77914H9.27532V8.98265Z" fill="#4F4F4F" />
                            <path d="M3.93604 21.7964V29.2714H11.4108V21.7964H3.93604ZM9.27532 27.136H6.07181V23.9325H9.27532V27.136Z" fill="#4F4F4F" />
                            <path d="M22.0894 3.64336V11.1181H29.5641V3.64336H22.0894ZM27.4283 8.98265H24.2248V5.77914H27.4283V8.98265Z" fill="#4F4F4F" />
                            <path d="M27.4283 13.2539V19.6609H22.0894V21.7964H29.5641V13.2539H27.4283Z" fill="#4F4F4F" />
                            <path d="M22.0894 23.9325V29.2714H24.2248V26.0679H27.4283V29.2714H29.5641V23.9325H22.0894Z" fill="#4F4F4F" />
                            <path d="M13.5466 3.64336V5.77914H17.8178V11.1181H19.9536V3.64336H13.5466Z" fill="#4F4F4F" />
                            <path d="M17.8178 13.2539V17.5254H13.5466V23.9325H17.8178V29.2714H19.9536V21.7964H15.6823V19.6609H19.9536V15.3897H22.0894V17.5254H24.2248V13.2539H17.8178Z" fill="#4F4F4F" />
                            <path d="M15.6823 26.0679H13.5466V29.2714H15.6823V26.0679Z" fill="#4F4F4F" />
                            <path d="M11.4108 17.5254H8.20727V19.6609H11.4108V17.5254Z" fill="#4F4F4F" />
                            <path d="M13.5466 7.9146V13.2539H3.93604V19.6609H6.07181V15.3897H15.6823V7.9146H13.5466Z" fill="#4F4F4F" />
                        </svg>
                        <h5>
                            QR
                            <a href="javascript:;" v-if="subscriptionDetails.inactive_static_qr_label == true" @click.prevent="upgradePlan">Upgrade</a>
                        </h5>
                    </div>
                    <div class="feature" v-bind:class="{'feature--inactive': subscriptionDetails.inactive_gps_checkin_label}">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.25 14.9711L29.5833 2.97107L17.5833 28.3044L14.9167 17.6377L4.25 14.9711Z" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <h5>
                            Remote
                            <a href="javascript:;" v-if="subscriptionDetails.inactive_gps_checkin_label == true" @click.prevent="upgradePlan">Upgrade</a>
                        </h5>
                    </div>
                    <div class="feature" v-bind:class="{'feature--inactive': subscriptionDetails.inactive_qr_card_label}">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.8982 4.72363H5.60143C4.65055 4.72363 3.73861 5.10137 3.06623 5.77375C2.39385 6.44613 2.01611 7.35807 2.01611 8.30895V24.6059C2.01611 25.5567 2.39385 26.4687 3.06623 27.1411C3.73861 27.8134 4.65055 28.1912 5.60143 28.1912H26.8982C27.8491 28.1912 28.761 27.8134 29.4334 27.1411C30.1058 26.4687 30.4835 25.5567 30.4835 24.6059V8.30895C30.4835 7.35807 30.1058 6.44613 29.4334 5.77375C28.761 5.10137 27.8491 4.72363 26.8982 4.72363ZM28.5279 24.6059C28.5279 25.0381 28.3562 25.4526 28.0506 25.7582C27.745 26.0638 27.3304 26.2355 26.8982 26.2355H5.60143C5.16921 26.2355 4.75469 26.0638 4.44907 25.7582C4.14344 25.4526 3.97174 25.0381 3.97174 24.6059V8.30895C3.97174 7.87673 4.14344 7.46221 4.44907 7.15659C4.75469 6.85096 5.16921 6.67926 5.60143 6.67926H26.8982C27.3304 6.67926 27.745 6.85096 28.0506 7.15659C28.3562 7.46221 28.5279 7.87673 28.5279 8.30895V24.6059Z" fill="#4F4F4F" />
                            <path d="M26.028 15.3166H18.9258C18.6664 15.3166 18.4177 15.4196 18.2344 15.603C18.051 15.7864 17.948 16.0351 17.948 16.2944C17.948 16.5538 18.051 16.8025 18.2344 16.9859C18.4177 17.1692 18.6664 17.2722 18.9258 17.2722H26.028C26.2873 17.2722 26.536 17.1692 26.7194 16.9859C26.9028 16.8025 27.0058 16.5538 27.0058 16.2944C27.0058 16.0351 26.9028 15.7864 26.7194 15.603C26.536 15.4196 26.2873 15.3166 26.028 15.3166Z" fill="#4F4F4F" />
                            <path d="M18.9258 13.361H22.4426C22.702 13.361 22.9507 13.258 23.1341 13.0746C23.3174 12.8912 23.4205 12.6425 23.4205 12.3832C23.4205 12.1238 23.3174 11.8751 23.1341 11.6918C22.9507 11.5084 22.702 11.4054 22.4426 11.4054H18.9258C18.6664 11.4054 18.4177 11.5084 18.2344 11.6918C18.051 11.8751 17.948 12.1238 17.948 12.3832C17.948 12.6425 18.051 12.8912 18.2344 13.0746C18.4177 13.258 18.6664 13.361 18.9258 13.361Z" fill="#4F4F4F" />
                            <path d="M10.8751 16.503C12.371 16.503 13.5837 15.2904 13.5837 13.7945C13.5837 12.2986 12.371 11.0859 10.8751 11.0859C9.37922 11.0859 8.16656 12.2986 8.16656 13.7945C8.16656 15.2904 9.37922 16.503 10.8751 16.503Z" fill="#4F4F4F" />
                            <path d="M10.8751 17.7612C9.91429 17.738 8.9655 17.9786 8.13174 18.4566C7.29799 18.9347 6.61113 19.6321 6.14575 20.473V21.8289H15.6305V20.473C15.1631 19.628 14.4721 18.9281 13.6334 18.4498C12.7946 17.9714 11.8403 17.7332 10.8751 17.7612Z" fill="#4F4F4F" />
                            <path d="M26.028 19.2279H18.9258C18.6664 19.2279 18.4177 19.3309 18.2344 19.5143C18.051 19.6976 17.948 19.9464 17.948 20.2057C17.948 20.465 18.051 20.7137 18.2344 20.8971C18.4177 21.0805 18.6664 21.1835 18.9258 21.1835H26.028C26.2873 21.1835 26.536 21.0805 26.7194 20.8971C26.9028 20.7137 27.0058 20.465 27.0058 20.2057C27.0058 19.9464 26.9028 19.6976 26.7194 19.5143C26.536 19.3309 26.2873 19.2279 26.028 19.2279Z" fill="#4F4F4F" />
                        </svg>
                        <h5>
                            Kiosk
                            <a href="javascript:;" v-if="subscriptionDetails.inactive_qr_card_label == true" @click.prevent="upgradePlan">Upgrade</a>
                        </h5>
                    </div>
                    <div class="feature" v-bind:class="{'feature--inactive': subscriptionDetails.inactive_is_supported_label}">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.75 20.3044C28.75 21.0116 28.469 21.6899 27.969 22.19C27.4689 22.6901 26.7906 22.9711 26.0833 22.9711H10.0833L4.75 28.3044V6.97107C4.75 6.26383 5.03095 5.58555 5.53105 5.08545C6.03115 4.58536 6.70942 4.30441 7.41667 4.30441H26.0833C26.7906 4.30441 27.4689 4.58536 27.969 5.08545C28.469 5.58555 28.75 6.26383 28.75 6.97107V20.3044Z" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M23.2456 8.78006H10.8101C10.5508 8.78006 10.302 8.88308 10.1187 9.06646C9.9353 9.24983 9.83228 9.49855 9.83228 9.75788C9.83228 10.0172 9.9353 10.2659 10.1187 10.4493C10.302 10.6327 10.5508 10.7357 10.8101 10.7357H23.2456C23.5049 10.7357 23.7537 10.6327 23.937 10.4493C24.1204 10.2659 24.2234 10.0172 24.2234 9.75788C24.2234 9.49855 24.1204 9.24983 23.937 9.06646C23.7537 8.88308 23.5049 8.78006 23.2456 8.78006Z" fill="#4F4F4F" />
                            <path d="M10.8101 18.4765H14.327C14.5863 18.4765 14.835 18.3735 15.0184 18.1901C15.2018 18.0068 15.3048 17.758 15.3048 17.4987C15.3048 17.2394 15.2018 16.9907 15.0184 16.8073C14.835 16.6239 14.5863 16.5209 14.327 16.5209H10.8101C10.5508 16.5209 10.302 16.6239 10.1187 16.8073C9.9353 16.9907 9.83228 17.2394 9.83228 17.4987C9.83228 17.758 9.9353 18.0068 10.1187 18.1901C10.302 18.3735 10.5508 18.4765 10.8101 18.4765Z" fill="#4F4F4F" />
                            <path d="M21.9123 12.6913H10.8101C10.5508 12.6913 10.302 12.7943 10.1187 12.9777C9.9353 13.1611 9.83228 13.4098 9.83228 13.6691C9.83228 13.9285 9.9353 14.1772 10.1187 14.3606C10.302 14.5439 10.5508 14.6469 10.8101 14.6469H21.9123C22.1716 14.6469 22.4203 14.5439 22.6037 14.3606C22.7871 14.1772 22.8901 13.9285 22.8901 13.6691C22.8901 13.4098 22.7871 13.1611 22.6037 12.9777C22.4203 12.7943 22.1716 12.6913 21.9123 12.6913Z" fill="#4F4F4F" />
                        </svg>
                        <h5>
                            Support
                            <a href="javascript:;" v-if="subscriptionDetails.inactive_is_supported_label == true" @click.prevent="upgradePlan">Upgrade</a>
                        </h5>
                    </div>
                </div>
            </div>
            <!-- In case of no tags -->
            <div class="section" v-if="emptyTags">
                <div class="section__body">
                    <div class="empty-state mb-4">
                        <img :src="base_url + '/admin/img/noTags.svg'" />
                        <h5>No Tags Added</h5>
                        <p>
                            Looks like there are no tags added yet <br />
                            Click below to create a new tag
                        </p>
                        <a href="#" class="btn btn-primary" @click.prevent="createTag"> + Add Tags</a>
                    </div>
                </div>
            </div>
            <!-- There are tags -->
            <div class="section" v-if="!emptyTags">
                <div class="section__header">
                    <div class="section__title">
                        <h5>Tags</h5>
                    </div>
                    <div class="section__actions">
                        <a href="#" @click.prevent="createTag">+ Add New Tag</a>
                    </div>
                </div>
                <div class="section__body">
                    <div class="tag__list">
                        <div class="tag__entry" v-for="tag in tags">
                            <h6>{{ tag.name }}</h6>
                            <div class="actions">
                                <a href="#" @click.prevent="editTag(tag)">
                                    <img :src="base_url + '/admin/img/edit.svg'" />
                                </a>
                                <a href="#" @click.prevent="deleteTag(tag)">
                                    <img :src="base_url + '/admin/img/delete.svg'" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- In case of no locations -->
            <div class="section" v-if="emptyLocations">
                <div class="section__body">
                    <div class="empty-state mb-4">
                        <img :src="base_url + '/admin/img/noLocation.svg'" />
                        <h5>No Locations Added</h5>
                        <p>
                            Looks like there are no locations added yet <br />
                            Click below to create a new location
                        </p>
                        <a href="#" class="btn btn-primary" @click.prevent="createLocation"> + Add Location</a>
                    </div>
                </div>
            </div>
            <div class="section" v-if="!emptyLocations">
                <div class="section__header">
                    <div class="section__title">
                        <h5>Locations</h5>
                        <p>Avaliable locations for this organisation</p>
                    </div>
                    <div class="section__actions" v-show="showCreateLocations"><a href="#" @click.prevent="createLocation">+ Add New Location</a></div>
                </div>
                <div class="section__body">
                    <div class="location__listing">
                        <div class="location__card" v-for="location in locations">
                            <vue-qrcode :value="location.qr_code" :options="{ width: 100 }"></vue-qrcode>
                            <a @click.prevent="editLocation(location)" href="#">{{ location.name }}</a>
                            <span class="text-success" v-if="location.primary_flag">(Primary)</span>
                            <p>Radius: {{ location.radius }} meters</p>
                            <div class="d-flex editable-button align-item-center">
                                <a class="download" href="javascript:;" @click.prevent="downloadLocationQR(location.id)">
                                    <img :src="base_url + '/admin/img/download.svg'" />
                                </a>
                                <a class="delete" href="#" @click.prevent="deleteLocation(location)">
                                    <img :src="base_url + '/admin/img/delete.svg'" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Manage Tag -->
        <div class="modal fade" id="manageTagModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-show="!tagEditMode" class="modal-title" id="exampleModalLabel">Add New Tag</h5>
                        <h5 v-show="tagEditMode" class="modal-title" id="exampleModalLabel">Edit Tag</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="manageTagForm" @submit.prevent="tagEditMode ? validateTagForm('update') : validateTagForm('store')">
                        <div class="modal-body">
                            <div class="form-group" :class="{ 'form-group--error': $v.tagsForm.name.$error }">
                                <label for="">Tag Title</label>
                                <input type="text" class="form-control" v-model="tagsForm.name" placeholder="Type the tag name here" />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save changes</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
      
        <!-- QR Add -->
        <div class="modal fade" id="manageLocationModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="!locationEditMode" id="exampleModalLabel">Add New Location</h5>
                        <h5 class="modal-title" v-show="locationEditMode" id="exampleModalLabel">Edit Location</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="manageLocationForm" @submit.prevent="locationEditMode ? validateLocationForm('update') : validateLocationForm('store')">
                        <div class="modal-body">
                            <div class="form-group" :class="{ 'form-group--error': $v.locationForm.name.$error }">
                                <label for="">Location Title</label>
                                <input type="text" class="form-control" name="title" v-model="locationForm.name" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.locationForm.latitude.$error }">
                                <label for="">Latitude</label>
                                <input type="text" class="form-control" name="latitude" v-model="locationForm.latitude" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.locationForm.longitude.$error }">
                                <label for="">Longitude</label>
                                <input type="text" class="form-control" name="longitude" v-model="locationForm.longitude" />
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="enable_radius" id="enable_radius" value='1' v-model="locationForm.enable_radius">
                                    <label class="form-check-label" for="enable_radius"> Enable Radius </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="is_primary" id="is_primary" value='1' v-model="locationForm.is_primary">
                                    <label class="form-check-label" for="is_primary"> Primary Location </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">Radius Value</label>
                                <input type="number" class="form-control" name='radius' v-model="locationForm.radius" />
                                <label class="text-muted">Add location raduis in Meters.</label>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save changes</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    data() {
        return {
            organizationDetails: {},
            subscriptionDetails: {},
            transactionDetails: {},
            tags: {},
            isPaymentCleared: true,
            emptyTags: false,
            tagEditMode: false,
            tagsForm: new Form({ id: '', name: "", _method: "post" }),
            showCreateLocations: true,
            emptyLocations: false,
            locations: {},
            locationEditMode: false,
            locationForm: new Form({ id: '', name: '', longitude: '', latitude: '', enable_radius: 0, radius: 0, _method: "post", is_primary: 0 }),
            subscriptions: {},
            upgradeForm: new Form({
                subscription_id: '',
                email: ''
            })
        }
    },
    validations: {
        tagsForm: {
            name: {required}
        },
        locationForm: {
            name: {required}, longitude: {required}, latitude: {required}
        },
    },
    mounted() {
        this.$route.meta.title = "Settings";
        this.getSettings();
        this.getTags();
        this.getLocations();
    },
    methods: {
        getSettings() {
            axios.get("/api/admin/settings").then(response => {
                this.organizationDetails = response.data.data.organization;
                this.subscriptionDetails = response.data.data.subscription;
                this.transactionDetails = response.data.data.transaction;
                this.isPaymentCleared = response.data.data.transaction.payment_details.is_payment_cleared;
            });
        },
        getTags() {
            axios.get("/api/admin/tags").then(response => {
                this.tags = response.data.data;
                if (Object.keys(response.data.data).length > 0) {
                    this.emptyTags = false;
                } else {
                    this.emptyTags = true;
                }
            });
        },
        createTag() {
            this.tagsForm.clear();
            this.tagsForm.reset();
            this.tagsForm._method = "post";
            this.tagEditMode = false;
            $("#manageTagModal").modal("show");
        },
        editTag(tag) {
            this.tagsForm.clear();
            this.tagsForm.reset();
            this.tagsForm.fill(tag);
            this.tagsForm._method = "put";
            this.tagEditMode = true;
            $("#manageTagModal").modal("show");
        },
        validateTagForm(action) {
            this.$v.$touch();
            if (!this.$v.tagsForm.$invalid) {
                switch(action) {
                    case "store":
                        this.storeTag();
                        break;
                    case "update":
                        this.updateTag();
                        break;
                }
            }
        },
        storeTag() {
            axios({
                method: "post",
                url: `/api/admin/tags`,
                data: this.tagsForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageTagModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.getTags();
                } else {
                    this.error_message = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        },
        updateTag() {
            axios({
                method: "post",
                url: `/api/admin/tags/${this.tagsForm.id}`,
                data: this.tagsForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageTagModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.getTags();
                } else {
                    this.error_message = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        },
        deleteTag(tag) {
            let $this = this;
            $.confirm({
                title: 'Confirmation!',
                content: `Are you sure to delete this tag (${tag.name})?`,
                buttons: {
                    confirm: {
                        btnClass: 'btn-red',
                        keys: ['enter'],
                        action: function() {
                            axios({
                                method: "delete",
                                url: `/api/admin/tags/${tag.id}`,
                            }).then((response) => {
                                if (response.data.status) {
                                    Toast.fire({ icon: 'success', title: response.data.message });
                                    $this.getTags();
                                } else {
                                    $.alert(response.data.message);
                                }
                            }, (error) => {
                                console.log(error)
                            });
                        }
                    },
                    cancel: function() {
                        Toast.fire({ icon: 'success', title: "Cancelled." });
                    }
                }
            });
        },
        getLocations() {
            axios.get("/api/admin/locations").then(response => {
                this.locations = response.data.data.records;
                if (Object.keys(response.data.data.records).length > 0) {
                    this.emptyLocations = false;
                } else {
                    this.emptyLocations = true;
                }
                this.showCreateLocations = response.data.data.creating_locations_availability;
            });
        },
        createLocation() {
            this.locationForm.clear();
            this.locationForm.reset();
            this.locationEditMode = false;
            $("#manageLocationModal").modal("show");
        },
        editLocation(location) {
            this.locationForm.clear();
            this.locationForm.reset();
            this.locationEditMode = true;
            this.locationForm.fill(location);
            $("#manageLocationModal").modal("show");
        },
        validateLocationForm(action) {
            this.$v.$touch();
            if (!this.$v.locationForm.$invalid) {
                switch(action) {
                    case "store":
                        this.storeLocation();
                        break;
                    case "update":
                        this.updateLocation();
                        break;
                }
            }
        },
        storeLocation() {
            axios({
                method: "post",
                url: `/api/admin/locations`,
                data: this.locationForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageLocationModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.getLocations();
                } else {
                    this.error_message = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        },
        updateLocation() {
            this.locationForm._method = "put";
            axios({
                method: "post",
                url: `/api/admin/locations/${this.locationForm.id}`,
                data: this.locationForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageLocationModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.getLocations();
                } else {
                    this.error_message = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        },
        deleteLocation(location) {
            let $this = this;
            $.confirm({
                title: 'Confirmation!',
                content: `Are you sure to delete this location (${location.name})?`,
                buttons: {
                    confirm: {
                        btnClass: 'btn-red',
                        keys: ['enter'],
                        action: function() {
                            axios({
                                method: "delete",
                                url: `/api/admin/locations/${location.id}`,
                            }).then((response) => {
                                if (response.data.status) {
                                    $("#manageLocationModal").modal("hide");
                                    Toast.fire({ icon: 'success', title: response.data.message });
                                    $this.getLocations();
                                } else {
                                    $.alert(response.data.message);
                                }
                            }, (error) => {
                                console.log(error)
                            });
                        }
                    },
                    cancel: function() {
                        Toast.fire({ icon: 'success', title: "Cancelled." });
                    }
                }
            });
        },
        downloadLocationQR(location_id) {
            let params = [{"name": "token", "value": localStorage.getItem("admin_auth")}];
            window.open(`/api/admin/locations/download-qr/${location_id}?` + $.param(params));
        },
        upgradePlan() {
            this.upgradeForm.clear();
            this.upgradeForm.reset();
            axios.get("/api/super/subscriptions?is_public=1").then(response => {
                this.subscriptions = response.data.data;
            });
            $("#upgradePlanModal").modal("show");
        },
        applyRequest() {
            axios({
                method: "post",
                url: `/api/admin/upgrade-plan`,
                data: this.upgradeForm
            }).then((response) => {
                if (response.data.status) {
                    $("#upgradePlanModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                } else {
                    this.error_message = response.data.message;
                }
            }, (error) => {
            });
        },
    },
}

</script>
